import LogrosCard from "@/components/LogrosCard";

export default function LogrosPage() {
  return (
    <div className="pt-2" data-testid="logros-page">
      <LogrosCard />
    </div>
  );
}
